const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect)
    } : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
        .closest(selectors.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    )
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
  
      });
    }
  }
}

 
// $(document).ready(function(){ 

//   let addressBtns = document.querySelectorAll('.js-address-btn');
//   let addressForms = document.querySelectorAll('.js-address-form');
//   let addressItems = document.querySelectorAll('.js-address-item');
  
//   addressBtns.forEach(addressBtn => {
//     addressBtn.addEventListener('click', () => {
  
//     if(!addressBtn.classList.contains('is-active')) {
//       addressBtns.forEach(element => {element.classList.remove('is-active');})
//       addressForms.forEach(element => {element.classList.remove('is-active');})
//       addressItems.forEach(element => {element.classList.remove('is-active');})
  
    
//       let selectedaddressForms = document.querySelector('.js-address-form[data-show="' + addressBtn.dataset.show + '"]');
//       let selectedaddressItems = document.querySelector('.js-address-item[data-show="' + addressBtn.dataset.show + '"]');
      
      
//       addressBtn.classList.add('is-active');
//       selectedaddressForms.classList.add('is-active');
//       selectedaddressItems.classList.add('is-active')
//     }

//     else {
//       let selectedaddressForms = document.querySelector('.js-address-form[data-show="' + addressBtn.dataset.show + '"]');
//       let selectedaddressItems = document.querySelector('.js-address-item[data-show="' + addressBtn.dataset.show + '"]');

//       addressBtn.classList.remove('is-active');
//       selectedaddressForms.classList.remove('is-active');
//       selectedaddressItems.classList.remove('is-active');
//     }
//   })
//   })
//   }) 


$(document).ready(function(){ 

  let addressItemBtns = document.querySelectorAll('.js-add-address-btn');
  let addressItemContent = document.querySelectorAll('.js-add-address-content');
  

  addressItemBtns[0].classList.add('is-active');
  addressItemContent[0].classList.add('is-active');
  

  addressItemBtns.forEach(addressItemBtn => {
  addressItemBtn.addEventListener('click', () => {

    if(!addressItemBtn.classList.contains('is-active')) {
      addressItemBtns.forEach(element => {element.classList.remove('is-active');})
      addressItemContent.forEach(element => {element.classList.remove('is-active');})
  
      let selectedaddItemContent = document.querySelector('.js-add-address-content[data-addaddress="' + addressItemBtn.dataset.addaddress + '"]');
      
      
      addressItemBtn.classList.add('is-active');
      selectedaddItemContent.classList.add('is-active');
    
  }
  })
  })
  })
  
  

$(document).ready(function(){ 
  let editAddressBtns = document.querySelectorAll('.js-address-btn');
  let editAddressContent = document.querySelectorAll('.js-edit-address-content');
  let addressItems = document.querySelectorAll('.js-address-item');
  let hiddenItems = document.querySelectorAll('.js-edit-address-hiden');
  let backBtns = document.querySelectorAll('.js-address-btn-back');
  let addressCards = document.querySelectorAll('.address-item__card');
  let addressCardWrapper = document.querySelectorAll('.address-item__card-wrapper');

  editAddressBtns.forEach(editAddressBtn => {
    editAddressBtn.addEventListener('click', () => {
      if(!editAddressBtn.classList.contains('is-active')) {
        editAddressBtns.forEach(element => {element.classList.remove('is-active');})
        editAddressContent.forEach(element => {element.classList.remove('is-active');})
        addressItems.forEach(element => {element.classList.add('is-hidden');})
        hiddenItems.forEach(element => {element.classList.add('is-hidden');})
        addressCardWrapper.forEach(element => {element.classList.add('is-hidden');})

        let selectedEditItemContent = document.querySelector('.js-address-item[data-editaddress="' + editAddressBtn.dataset.editaddress + '"] .js-edit-address-content ');   
        let selectedAddressItem = document.querySelector('.js-address-item[data-editaddress="' + editAddressBtn.dataset.editaddress + '"]');
        let selectedAddressCard = document.querySelector('.js-address-item[data-editaddress="' + editAddressBtn.dataset.editaddress + '"] .address-item__card');
   
        editAddressBtn.classList.add('is-active');
        selectedEditItemContent.classList.add('is-active');
        selectedAddressItem.classList.remove('is-hidden');
        selectedAddressItem.classList.add('is-active');
        selectedAddressCard.classList.add('is-hidden')
      }
    })
  })

  backBtns.forEach(backBtn => {
  backBtn.addEventListener('click', () => {

    editAddressBtns.forEach(element => {element.classList.remove('is-active');})
    editAddressContent.forEach(element => {element.classList.remove('is-active');})
    addressItems.forEach(element => {element.classList.remove('is-hidden', 'is-active');})
    hiddenItems.forEach(element => {element.classList.remove('is-hidden');})
    addressCards.forEach(element => {element.classList.remove('is-hidden');})
    addressCardWrapper.forEach(element => {element.classList.remove('is-hidden');})

  })
})
  
})



$(document).ready(function(){ 

  let passwordItemBtns = document.querySelectorAll('.js-edit-password');
  let passwordItemContent = document.querySelectorAll('.js-edit-password-content');
  let personalHiddenItems = document.querySelectorAll('.js-personal-item-hidden');
  let passwordBackBtns = document.querySelectorAll('.js-password-btn-back');
  

  passwordItemBtns.forEach(passwordItemBtn => {
    passwordItemBtn.addEventListener('click', () => {

    if(!passwordItemBtn.classList.contains('is-active')) {
      passwordItemBtns.forEach(element => {element.classList.remove('is-active');})
      passwordItemContent.forEach(element => {element.classList.remove('is-active');})
      personalHiddenItems.forEach(element => {element.classList.add('is-hidden');})
  
      let selectedpasswordItemContent = document.querySelector('.js-edit-password-content[data-editpass="' + passwordItemBtn.dataset.editpass + '"]');
      
      
      passwordItemBtn.classList.add('is-active');
      selectedpasswordItemContent.classList.add('is-active');
  }
  })
  })

  passwordBackBtns.forEach(passwordBackBtn => {
    passwordBackBtn.addEventListener('click', () => {
  
      passwordItemBtns.forEach(element => {element.classList.remove('is-active');})
      passwordItemContent.forEach(element => {element.classList.remove('is-active');})
      personalHiddenItems.forEach(element => {element.classList.remove('is-hidden');})
  
    })
  })
  })